@if (showBanner) {
  <div class="cookie-banner-mount-point">
    <section class="gdpr-cookie-banner">
      <p class="disclaimer-text">
        Select "Accept all" to agree to our use of cookies and similar technologies to enhance your
        browsing experience, security, analytics and customization. Select "Manage cookies" to make
        more choices or opt out.
      </p>

      <div class="banner-actions">
        <button mat-flat-button color="secondary" class="manage" (click)="openSettings()">
          <span>Manage cookies</span>
        </button>
        <button mat-flat-button color="primary" class="accept" (click)="acceptAll()">
          <span>Accept all</span>
        </button>
      </div>
    </section>
  </div>
}
